module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAANRJREFUKBW1krENwjAQRRNgBwagIaKFFoFgAuZBQoxAhdgmNamBigI6BkA0oPB+5CORZUPFSZf/z/e/z0mcJF6UZXkkQ3Fmce7J61KOuqqZ2+kRNX8xHpz5XG1HsSGf5JUckMGJNvvTh8hksRQxUQidcNah2W4IKv7LjH7Xapia9E6RkzcPta7oxYxFmqZTBFsPi8rGQ0cNRcZxVzQW7pUNMxPHjCcmrWXycIKxK3PM+N+JLybbLxFXjjhmDvZBfSTDIVxRJDTs5lzgujlWQ4OxZ3X8BpMG7SmrPt50AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/ic-fax.png
// module id = 1404
// module chunks = 0